import { CJAtelier } from 'types/cj';
import { isAtelierEmpty } from './isAtelierEmpty';

export function areAteliersEmpty(ateliers: CJAtelier[]): boolean {
  // If any pivot has position>1, we consider it in "rotate" mode
  return ateliers.every(a => isAtelierEmpty(a));
}
